import { memo, useEffect, useRef, useState } from 'react';

import { FormField } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';

import { SAVE_TO_PARENT_KEY } from '../../../../utils/postingUtils';
import { customConstraints } from '../../../../utils/formValidation';

import TextFormField from '../../../../components/WizardModularListing/FormFields/TextFormField';

import type { ChangeEvent } from 'react';

const RoomSquareFootageFormField = () => {
  const {
    properties: {
      currentProperty: { floorplans },
    },
  } = useSelector((state) => state);

  const [errorObj, setErrorObj] = useState(null);

  const refRoomSquareFeet = useRef<number>();

  // a reference to the components clear field error function
  const refClearFieldError = useRef(null);

  const {
    floorPlanId,
    squareFeet,
    roomForRent: { roomSquareFeet },
  } = floorplans[0];

  useEffect(() => {}, [errorObj]);

  const handleBlur = (event: ChangeEvent<HTMLSelectElement>) => {
    setErrorObj(null);

    const { value } = event.target;

    refRoomSquareFeet.current = Number(value);
  };

  /**
   *
   * @returns obj { response: bool, message: string }
   */
  const isRoomSqftLessThanSqft = () => {
    // skip validation if square feet is empty
    if (!squareFeet) {
      return {
        response: true,
        message: '',
      };
    }

    return customConstraints.isRoomSqrftLTESqrft(Number(refRoomSquareFeet.current), squareFeet);
  };

  return (
    <FormField>
      <TextFormField
        dataTestId="RoomSquareFeet"
        inputName="roomSquareFeet"
        label="Room square footage"
        placeholder=""
        initialValue={roomSquareFeet}
        castToDataType="Number"
        floorPlanId={floorPlanId}
        required={false}
        saveToParentKey={SAVE_TO_PARENT_KEY.FLOOR_PLANS_ROOM_FOR_RENT}
        passNullWhenEmptyString={true}
        rightAdornmentContent="sq. ft."
        errorObj={errorObj}
        refClearFieldError={refClearFieldError}
        handleBlur={handleBlur}
        isExternalConditionValid={isRoomSqftLessThanSqft}
      />
    </FormField>
  );
};

export default memo(RoomSquareFootageFormField);
